import React, { FunctionComponent, useEffect, useState } from 'react'

import { Grid } from '@material-ui/core'
import ContainerPage from 'shared/components/ContainerPage'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import { IFind } from 'shared/modules/termosUso/domain/usecases/Find'
import { colors } from 'shared/styles/colors'

import { Container } from './styles'

type TProps = {
  find: IFind
}

const DetalhesTermosUso: FunctionComponent<TProps> = ({ find }) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState('')
  const [termos, setTermos] = useState('')

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        const response = await find.execute()

        setTermos(response)
      } catch (error) {
        setMessages(
          'Não foi possível carregar os termos de uso, por favor tente novamente em alguns minutos.',
        )
        setOpen(true)
      } finally {
        setLoading(false)
      }
    }

    init()
  }, [])

  return (
    <ContainerPage breadCrumb="Termos de uso" showFooterScaffold={false}>
      {loading ? (
        <LoadingBackdrop open={loading} color={colors.green} />
      ) : messages ? (
        <span>
          Não foi possível carregar os termos de uso, por favor tente novamente
          em alguns minutos.
        </span>
      ) : (
        <>
          <Grid item xs={12}>
            <Container dangerouslySetInnerHTML={{ __html: termos }} />
          </Grid>
        </>
      )}
      <SnackBar
        open={open}
        message={messages}
        setOpen={setOpen}
        severity={'error'}
      />
    </ContainerPage>
  )
}

export default DetalhesTermosUso
